import { format, isSameMinute, Locale, parse } from 'date-fns'

import { TourTime } from '@app/models'

export const getTourTime = (
  timeFormat: string,
  locale: Locale,
  tourTime?: TourTime[]
): string | null => {
  if (!tourTime || tourTime.length == 0) {
    return null
  }

  const result = tourTime.map((time) => {
    if (!time.from || !time.to) {
      return null
    }

    const now = new Date()
    const localTime = format(now, 'p', { locale })
    const useAMPM = localTime.includes('AM') || localTime.includes('PM')

    const timeFrom = parse(time.from, timeFormat, new Date())
    const timeTo = parse(time.to, timeFormat, new Date())

    const isAMFrom = timeFrom.getHours() < 12
    const isAMTo = timeTo.getHours() < 12

    let formatFrom = useAMPM ? 'h' : 'HH'
    let formatTo = useAMPM ? 'h' : 'HH'

    if (!useAMPM || !isSameMinute(now, timeFrom)) {
      formatFrom += ':mm'
    }
    if (!useAMPM || !isSameMinute(timeFrom, timeTo)) {
      formatTo += ':mm'
    }

    if (useAMPM && isAMFrom !== isAMTo) {
      formatFrom += 'aaa'
    }

    const timeFromFormatted = format(timeFrom, formatFrom, { locale })
    const timeToFormatted = format(timeTo, formatTo, { locale })

    return (
      (isSameMinute(timeFrom, timeTo) && timeToFormatted) ||
      `${timeFromFormatted}\u2212${timeToFormatted}`
    )
  })

  return result.filter((x) => x != null).join(', ')
}
